const translations = {
    maxExceededErrorMessage: 'Too many characters',
    requiredErrorMessage: 'This field is required'
};

export default translations;
